/**
 * 全局 message API 持有者
 * 用于在非组件代码（如 api.ts 的 axios 拦截器）中访问 antd 的 message API
 * 需要在 App.tsx 中通过 inner component 初始化
 */
import type {MessageInstance} from 'antd/es/message/interface';

let messageApi: MessageInstance | null = null;

export const setMessageApi = (api: MessageInstance): void => {
    messageApi = api;
};

export const getMessageApi = (): MessageInstance | null => {
    return messageApi;
};
